var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerialNoIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53335 14.4H7.46668C7.17228 14.4 6.93335 14.1611 6.93335 13.8667V2.13333C6.93335 1.83893 7.17228 1.6 7.46668 1.6H8.53335C8.82775 1.6 9.06668 1.83893 9.06668 2.13333V13.8667C9.06668 14.1611 8.82775 14.4 8.53335 14.4Z",
    fill: "url(#paint0_linear_209_12614)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.809 10.7381L13.2757 11.6619C13.1285 11.9168 12.8021 12.0043 12.5472 11.8571L2.38557 5.9904C2.13064 5.8432 2.04317 5.5168 2.19037 5.26187L2.72371 4.33813C2.87091 4.0832 3.19731 3.99573 3.45224 4.14293L13.6138 10.0096C13.8693 10.1568 13.9562 10.4832 13.809 10.7381Z",
    fill: "url(#paint1_linear_209_12614)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2757 4.33813L13.809 5.26187C13.9562 5.5168 13.8688 5.8432 13.6138 5.9904L3.45224 11.8571C3.19731 12.0043 2.87091 11.9168 2.72371 11.6619L2.19037 10.7381C2.04317 10.4832 2.13064 10.1568 2.38557 10.0096L12.5472 4.14293C12.8026 3.99573 13.1285 4.0832 13.2757 4.33813Z",
    fill: "url(#paint2_linear_209_12614)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_12614",
    x1: 8.00002,
    y1: 1.6,
    x2: 8.00002,
    y2: 14.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3484FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_12614",
    x1: 7.99977,
    y1: 4.07146,
    x2: 7.99977,
    y2: 11.9285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3484FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_12614",
    x1: 7.99971,
    y1: 4.07146,
    x2: 7.99971,
    y2: 11.9285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3484FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07F04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerialNoIconColored);
export default __webpack_public_path__ + "static/media/serial_no_icon_colored.f1a210d52c77ccbcb000c1cea03afb39.svg";
export { ForwardRef as ReactComponent };